import { Injectable, Inject } from '@angular/core';
import { AuthHttp } from 'angular2-jwt';
import { APIBase } from './api.base';
import { Router } from '@angular/router';
import { SessionStorageService } from '../services/session-storage.service';

@Injectable()
export class ProcessAPI extends APIBase {

	constructor(@Inject(AuthHttp) authHttp: AuthHttp, @Inject(Router) router: Router, @Inject(SessionStorageService) session: SessionStorageService) {
		super(authHttp, router, session);

		// Entidade principal
		this.__entity = 'process';
	}

	/**
	 * get_grouped_processes
	 *
	 * busca lista de processos
	 *
	 * @access public
	 * @author Jeferson Carvalho
	 * @since  01/2019
	 * @return object Promise
	 */
	public get_grouped_processes(filter?: number, days?: number) {
		return this._call(this.__entity + '/get_grouped_processes/', { filter: filter, days: days }, 'get');
	}
	/**
	 * updateProcess
	 *
	 * update no processo setando incorporadora, empreendimento, edificio e unidade
	 *
	 * @access public
	 * @author Nicolas Aoki
	 * @since  11/2019
	 * @return object Promise
	 */
	public updateProcess(data) {
		return this._call(this.__entity + '/updateProcess/', { data }, 'post');
	}
	/**
	 * getIncorporadoraInfo
	 *
	 * Procura incorporadora atrelado ao processo
	 *
	 * @access public
	 * @author Nicolas Aoki
	 * @since  11/2019
	 * @return object Promise
	 */
	public getIncorporadoraInfo(processoId) {
		return this._call(this.__entity + '/getIncorporadoraInfo/', { processoId }, 'get');
	}
	/**
	* download_report
	*
	* Relatorio de todos os campos do sistema
	*
	* @access public
	* @author Nicolas Aoki
	* @since  09/2019
	* @return object Promise
	*/
	public download_report_process(day?, calendar?) {

		if (!calendar) {
			return this.getBlob(this.__entity + '/download_resource/', { days: day });
		} else {
			return this.getBlob(this.__entity + '/download_resource/', { calendar: calendar });
		}
	}

	public updateManyStatusProcess(data) {
		return this._call(this.__entity + '/bulk-update-status', data, 'put'); 
	}
}


// WEBPACK FOOTER //
// ./src/api/process.api.ts